

$(function(){
  // ページ内リンク
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });
  // スクロールアクション
  $(window).on('load scroll',function(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        var w = $( window ).width() ;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.25;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('active');
        }else{
          This.removeClass('active');
        }
    });
  });

  $('.header_btn').click(function(){
    $('header').toggleClass('active');
    $('.header_btn').toggleClass('open');
  });
  $('.header_menu a').click(function(){
    $('header').removeClass('active');
    $('.header_btn').removeClass('open');
  });

});
